import { IManufacturer } from '@models/Manufacturer.model';

import ReactDom from 'react-dom';

import { State } from '@hookstate/core';

import { useState as classicUseState } from 'react';
import { Icon as BlueIcon } from '@blueprintjs/core';

import FormControlLabel from '@material-ui/core/FormControlLabel';

import CheckBox from '@assets/svg/checkbox.svg';

import { withStyles } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';

import { useMutation, useQueryClient } from 'react-query';

import { useParams } from 'react-router-dom';
import { useFieldArray, useForm } from 'react-hook-form';
import { IContact } from '@models/Contact.model';
import { changeContact } from '@services/queries/contact/changeContact/changeContact';
import {
  AssociateText,
  GlobalHeader,
  CheckCircle,
  Label,
  RowDiv,
  UncheckCircle,
  Input,
  Container,
  Bottom,
  BottomText,
  Cancel,
  Confirm,
  Close2,
  Header2,
  Title,
  Overlay,
  Divider,
  AddButton,
  IconContainer,
  Row,
  ColumnDiv,
  Body,
  Form,
} from './EditContacts.styles';

const BlueCheckbox = withStyles({
  root: {
    color: blue[300],
    '&$checked': {
      color: blue,
    },
  },
  checked: {},
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);
interface ContactProps {
  manufacturerData?: IManufacturer;
  openEditContact: State<boolean>;
  contact: IContact;
}

interface IForm {
  phones: Array<{ id?: string; phone: string; label: string }>;
  emails: Array<{ id?: string; email: string; label: string }>;
  name: string;
  title: string;
}

/**
 * # Note
 *  This should only be called with a manufacturer (and product), else it may edit unintended data. See mutationEditContact.mutate
 */
const EditContacts = ({
  manufacturerData,
  openEditContact,
  contact,
}: ContactProps) => {
  const portalDiv = document.getElementById('portal');

  const params = useParams<{ equipmentId: string }>();

  const queryClient = useQueryClient();

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { isValid },
  } = useForm<IForm>({
    defaultValues: {
      phones:
        contact.phones.length > 0
          ? contact.phones.map(item => ({
              id: item.id,
              phone: item.phone,
              label: item.label,
            }))
          : [{ phone: '', label: '' }],
      emails:
        contact.emails.length > 0
          ? contact.emails.map(item => ({
              id: item.id,
              email: item.email,
              label: item.label,
            }))
          : [{ email: '', label: '' }],
      name: contact.name,
      title: contact.title,
    },
    reValidateMode: 'onChange',
  });
  const phonesField = useFieldArray({
    control,
    name: 'phones',
  });
  const emailsField = useFieldArray({
    control,
    name: 'emails',
  });

  const [associateTo, setAssociateTo] = classicUseState<
    'product' | 'manufacturer' | 'global'
  >(contact.isGlobal ? 'global' : 'manufacturer');

  const [firstPhone, setFirstPhone] = classicUseState<string>(
    contact.phones.length > 0 ? contact.phones[0].phone : '',
  );
  const [firstEmail, setFirstEmail] = classicUseState<string>(
    contact.emails.length > 0 ? contact.emails[0].email : '',
  );

  const clearStates = () => {
    reset();
    setFirstPhone('');
    setFirstEmail('');
    setAssociateTo('manufacturer');
  };

  const mutationEditContact = useMutation(changeContact, {
    onSuccess: () => {
      clearStates();
      openEditContact.set(false);
      queryClient.invalidateQueries([
        'equipments',
        params.equipmentId,
        'contacts',
      ]);
    },
    onError: () => {
      //    toast.error('Updated failed!');
    },
  });

  const onSubmit = (formData: IForm) => {
    if (!mutationEditContact.isLoading) {
      mutationEditContact.mutate({
        data: {
          contactId: contact.id,
          manufacturerId:
            associateTo === 'manufacturer' ? manufacturerData?.id : undefined,
          title: formData.title,
          isGlobal: associateTo === 'global',
          name: formData.name,
          phones: formData.phones.filter(phone => !!phone.phone || !!phone.id),
          emails: formData.emails.filter(email => !!email.email || !!email.id),
        },
      });
    }
  };

  if (!manufacturerData) return <div>Manufacturer info missing</div>;

  return openEditContact.get() && portalDiv
    ? ReactDom.createPortal(
        <Overlay>
          <Container>
            <Header2>
              <Title>Edit Contact</Title>
              <Close2 onClick={() => openEditContact.set(false)}>
                <BlueIcon icon="cross" color="#8f95b2" />
              </Close2>
            </Header2>
            <Body>
              <Form onSubmit={handleSubmit(onSubmit)} id="editContactForm">
                <Label>Contact Name</Label>
                <Divider height="8px" />
                <Input
                  {...register('name')}
                  required
                  placeholder="EX: Local Service Contact"
                />

                <Divider height="16px" />

                <Label className="labelOptional">Title (Optional)</Label>
                <Divider height="8px" />
                <Input
                  {...register('title')}
                  placeholder="EX: Local Service Contact"
                />

                <Divider height="16px" />
                <Row>
                  <ColumnDiv>
                    <Label>Phone Number</Label>
                    <Divider height="8px" />
                  </ColumnDiv>
                  <ColumnDiv>
                    <Label className="labelOptional">
                      Number Label (Optional)
                    </Label>
                    <Divider height="8px" />
                  </ColumnDiv>
                </Row>

                {phonesField.fields.map((field, index) => (
                  <Row key={field.id}>
                    <ColumnDiv>
                      {index !== 0 && <Divider height="16px" />}
                      <Input
                        key={field.id}
                        {...register(`phones.${index}.phone`)}
                        onChange={e => {
                          register(`phones.${index}.phone`).onChange(e);
                          if (index === 0) {
                            setFirstPhone(e.target.value);
                          }
                        }}
                        type="tel"
                        pattern="[^a-zA-Z@]+$"
                        required={index === 0 && !firstEmail && !firstPhone}
                        placeholder="EX: 999-999-9999"
                      />
                    </ColumnDiv>
                    <ColumnDiv>
                      {index !== 0 && <Divider height="16px" />}
                      <Input
                        key={field.id}
                        {...register(`phones.${index}.label`)}
                        placeholder="EX: Work Contact"
                      />
                    </ColumnDiv>
                  </Row>
                ))}

                <Divider height="16px" />

                <AddButton
                  type="button"
                  onClick={() => {
                    phonesField.append({ phone: '', label: '' });
                  }}
                >
                  <IconContainer>
                    <BlueIcon icon="plus" color="#8f95b2" />
                  </IconContainer>
                </AddButton>

                <Divider height="16px" />
                <Row>
                  <ColumnDiv>
                    <Label>Email</Label>
                    <Divider height="8px" />
                  </ColumnDiv>
                  <ColumnDiv>
                    <Label className="labelOptional">
                      Email Label (Optional)
                    </Label>
                    <Divider height="8px" />
                  </ColumnDiv>
                </Row>

                {emailsField.fields.map((field, index) => (
                  <Row key={field.id}>
                    <ColumnDiv>
                      {index !== 0 && <Divider height="16px" />}
                      <Input
                        key={field.id}
                        {...register(`emails.${index}.email`)}
                        onChange={e => {
                          register(`emails.${index}.email`).onChange(e);
                          if (index === 0) {
                            setFirstEmail(e.target.value);
                          }
                        }}
                        type="email"
                        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                        required={index === 0 && !firstEmail && !firstPhone}
                        placeholder="EX: contact@contact.com"
                      />
                    </ColumnDiv>
                    <ColumnDiv>
                      {index !== 0 && <Divider height="16px" />}
                      <Input
                        key={field.id}
                        {...register(`emails.${index}.label`)}
                        placeholder="EX: Main Address"
                      />
                    </ColumnDiv>
                  </Row>
                ))}

                <Divider height="16px" />

                <AddButton
                  type="button"
                  onClick={() => {
                    emailsField.append({ email: '', label: '' });
                  }}
                >
                  <IconContainer>
                    <BlueIcon icon="plus" color="#8f95b2" />
                  </IconContainer>
                </AddButton>

                <Divider height="16px" />

                <GlobalHeader>Associate to</GlobalHeader>
                <div
                  style={{
                    flexDirection: 'row',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    marginBottom: 8,
                    width: '100%',
                  }}
                >
                  <RowDiv>
                    <FormControlLabel
                      style={{ margin: 0 }}
                      control={
                        <BlueCheckbox
                          icon={<UncheckCircle />}
                          checkedIcon={
                            <CheckCircle src={CheckBox} alt="CheckBox" />
                          }
                          name="checkedH"
                        />
                      }
                      label=""
                      checked={associateTo === 'manufacturer'}
                      onClick={() => setAssociateTo('manufacturer')}
                    />
                    <Label>Manufacturer</Label>
                  </RowDiv>
                  <RowDiv>
                    <FormControlLabel
                      style={{ margin: 0 }}
                      control={
                        <BlueCheckbox
                          icon={<UncheckCircle />}
                          checkedIcon={
                            <CheckCircle src={CheckBox} alt="CheckBox" />
                          }
                          name="checkedH"
                        />
                      }
                      label=""
                      checked={associateTo === 'global'}
                      onClick={() => setAssociateTo('global')}
                    />
                    <Label>Global Contact</Label>
                  </RowDiv>
                </div>
                {associateTo === 'global' && (
                  <AssociateText>
                    This contact will be available for any product or
                    manufacturer.
                  </AssociateText>
                )}
                {associateTo === 'manufacturer' && (
                  <AssociateText>
                    {`This contact will be available for ${manufacturerData?.name} products.`}
                  </AssociateText>
                )}

                {associateTo === 'product' && (
                  <AssociateText>
                    This contact will be available for any of the selected
                    product.
                  </AssociateText>
                )}
                {(associateTo === 'global' ||
                  associateTo === 'manufacturer') && (
                  <div style={{ height: '100%' }} />
                )}
              </Form>
            </Body>

            <Bottom>
              <BottomText>
                Tip: At least one Phone Number or Email need to be added, but
                having both is not required.
              </BottomText>
              <Cancel onClick={clearStates} type="button">
                Reset
              </Cancel>
              <Divider width="8px" />
              <Confirm
                type="submit"
                form="editContactForm"
                disabled={!isValid || mutationEditContact.isLoading}
              >
                Save
              </Confirm>
            </Bottom>
          </Container>
        </Overlay>,
        portalDiv,
      )
    : null;
};
//
export { EditContacts };
